import { useActiveStudyPackCollectionId } from "@hooks/useActiveStudyPackCollectionId";
import useMixedItemDist from "@hooks/useMixedItemDist";
import { useStudyPackAccess } from "@hooks/useStudyPackAccess";
import type { MixedItemTag } from "@memorang/types";

/** Tag structure changes far less often than progress, so it outlives the primary distribution's window. */
const PREMIUM_TAGS_STALE_TIME = 30 * 60 * 1000;

export const usePremiumStudyPackTags = (): MixedItemTag[] | undefined => {
	const { hasStudyPackPurchaseAccess } = useStudyPackAccess();
	const { studyPackCollectionId, freeStudyPackCollectionId } =
		useActiveStudyPackCollectionId();

	const enabled =
		!hasStudyPackPurchaseAccess &&
		Boolean(freeStudyPackCollectionId) &&
		Boolean(studyPackCollectionId) &&
		studyPackCollectionId !== freeStudyPackCollectionId;

	const { data } = useMixedItemDist({
		action: "GET_STUDYPACK_DISTRIBUTION",
		collectionId: studyPackCollectionId,
		enabled,
		staleTime: PREMIUM_TAGS_STALE_TIME,
		retry: false,
	});

	return enabled ? data?.tags : undefined;
};
